import React, { useEffect } from "react";
import { useNavigate } from "react-router";

const LogoutScreen = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/login");
    }, [navigate]);

    useEffect(() => {
        try {
            window.Intercom?.("shutdown");
        } catch (e) {
            console.warn("Intercom shutdown failed:", e);
        }
    }, []);

    return (
        <div className="app flex-row align-items-center">
            Logout erfolgreich.
            <br />
            Zum <a href="/login">Login</a>
        </div>
    );
};

export default LogoutScreen;
